module.exports = {
      id: "prothomalo-trust-usage",
      viewBox: "0 0 260 65",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#prothomalo-trust",
      toString: function () {
        return this.url;
      }
    }